

<div class="row main-visor">
  <div class="col-12">
    <nb-card>
      <nb-card-header>
        <nav class="navbar navigation">
          <div class="title-filter">
          <span><nb-icon icon="draw-polygon" pack="font-awesome"></nb-icon> Editor de parcela</span>



        </div>
          <button nbButton status="primary" (click)="back()"><nb-icon icon="arrow-back"></nb-icon>
          </button>

        </nav>

      </nb-card-header>

      <nb-card-body>

        <div class="row formulario" [nbSpinner]="loading"
        nbSpinnerStatus="danger"
        nbSpinnerSize="large"
        [nbSpinnerMessage]="loadingMessage">

            <div class="col-4">
              <form autocomplete="off">
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label for="parcelaname" class="label">Nombre</label>
                    <input #parcelaname type="text" nbInput fullWidth id="parcelaname" name="parcelaname" [(ngModel)]="parcela.name" autofocus/>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label for="parcelaregion" class="label">Región/Productor</label>
                    <input type="text" nbInput fullWidth id="parcelaregion" name="parcelaregion" [(ngModel)]="parcela.region"
                    [nbAutocomplete]="autoControl"/>

                    <nb-autocomplete #autoControl>

                      <nb-option *ngFor="let region of filteredRegions$ | async" [value]="region">
                        {{ region }}
                      </nb-option>

                    </nb-autocomplete>
                  </div>
                </div>
              </div>
              <div class="row">
                <div *ngIf="parcela.id != 0" class="col-md-4">
                  <button nbButton fullWidth status="danger" (click)="eliminar()" ><nb-icon icon="trash-2-outline"></nb-icon></button>
                </div>

                <div class="col-md-6">
                  <button nbButton fullWidth status="primary" (click)="guardar()" ><nb-icon icon="save"></nb-icon>Guardar</button>
                </div>
                <div class="col-md-2">
                  <button nbPopoverPlacement="right"
                  nbPopoverAdjustment="noop"
                  nbPopoverTrigger="hint"
                  [nbPopover]="popoverHelp" nbButton shape="round" status="success"><nb-icon icon="info"></nb-icon></button>
                </div>
                <ng-template #popoverHelp>
                  <p>Para eliminar un vertice mantenga pulsada la tecla <b>SHIFT</b>.</p>
                  <p>Para crear nuevos vertice pinche en el perímetro de la geometría y arrastre.</p>
                </ng-template>
              </div>
            </form>
            </div>

            <div class="col-8">
              <div *ngIf="parcela.polygon == null" class="row">
                <div class="col-12">
                  <div class="form-group">

                    <input type="text" nbInput fullWidth id="busqueda" name="busqueda" placeholder="Localidad, Region, Pais" [(ngModel)]="busquedaLocalidad"
                    (keyup.enter)="buscarLocalidad()"/>
                  </div>
                </div>
              </div>
              <div class="row mapa" >
                <div class="panel-body map-container" [attr.id]="config.target" #mapa ></div>
              </div>

            </div>
        </div>






      </nb-card-body>
    </nb-card>
  </div>



  </div>

  <ng-template #deleteconfirmation let-data let-ref="dialogRef">
    <nb-card>
      <nb-card-header>Eliminar PARCELA</nb-card-header>
      <nb-card-body>¿Realmente desea eliminar esta parcela?


      </nb-card-body>
      <nb-card-footer>
        <div class="row">
          <div class="col-md-6">
            <button nbButton status="primary" (click)="ref.close()">Cancelar</button>
          </div>
          <div class="col-md-6 text-right">
            <button nbButton status="danger" (click)="confirmarEliminar();ref.close()">Eliminar</button>
          </div>
        </div>
      </nb-card-footer>
    </nb-card>
  </ng-template>

